// ─── ApiError ─────────────────────────────────────────────────────────────────
// Single error class for all API failures.
// Callers catch ApiError to show user-facing messages; unexpected errors bubble up.

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

export const isApiError = (e: unknown): e is ApiError => e instanceof ApiError;

/** Wrap an unknown catch value into ApiError for uniform handling. */
export const toApiError = (e: unknown): ApiError => {
  if (isApiError(e)) return e;
  const msg = e instanceof Error ? e.message : 'An unexpected error occurred';
  return new ApiError(0, msg);
};
